import React from 'react';
import css from './Section.module.css';
import { PrimaryButton } from '../../../components';
import Icons from '../../../components/Icons/Icons';
import classNames from 'classnames';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';

function SectionEnjoyTheExperience(props) {
  const { intl } = props;
  const history = useHistory();

  return (
    <div className={css.experienceSection}>
      <div className={css.fixedWidthContainer}>
        <div className={css.experienceHead}>
          <div className={css.sectionHead}>
            <h2>{intl.formatMessage({ id: 'SectionEnjoyTheExperience.title' })}</h2>
            <PrimaryButton onClick={() => history.push('/s')}>
              {intl.formatMessage({ id: 'SectionEnjoyTheExperience.learnMore' })}{' '}
              <Icons name="rightAngle" />
            </PrimaryButton>
          </div>
          <div className={css.experienceHeadContent}>
            <p>{intl.formatMessage({ id: 'SectionEnjoyTheExperience.description1' })}</p>
            <p>{intl.formatMessage({ id: 'SectionEnjoyTheExperience.description2' })}</p>
          </div>
        </div>

        <div className={css.layoutContainer}>
          <div className={css.imageRow}>
            <div className={css.imgBlock}>
              <img
                src="https://d1hdnpfpyy58x9.cloudfront.net/context/frontend/landing/landing02/experience_01.jpg,w_278,h_279,c_1,q_80,fd_1,e_.webp"
                alt={intl.formatMessage({ id: 'SectionEnjoyTheExperience.imageAlt1' })}
              />
            </div>
            <div className={css.imgBlock}>
              <img
                src="https://d1hdnpfpyy58x9.cloudfront.net/context/frontend/landing/landing02/experience_02.jpg,w_278,h_279,c_1,q_80,fd_1,e_.webp"
                alt={intl.formatMessage({ id: 'SectionEnjoyTheExperience.imageAlt2' })}
              />
            </div>
          </div>

          <div className={css.imageRow}>
            <div className={css.imgBlock}>
              <img
                src="https://d1hdnpfpyy58x9.cloudfront.net/context/frontend/landing/landing02/experience_03.jpg,w_278,h_400,c_1,q_80,fd_1,e_.webp"
                alt={intl.formatMessage({ id: 'SectionEnjoyTheExperience.imageAlt3' })}
              />
            </div>
            <div className={classNames(css.imgBlock, css.imgBlockMobile)}>
              <img
                src="https://d1hdnpfpyy58x9.cloudfront.net/context/frontend/landing/landing02/experience_04.jpg,w_278,h_390,c_1,q_80,fd_1,e_.webp"
                alt={intl.formatMessage({ id: 'SectionEnjoyTheExperience.imageAlt4' })}
              />
            </div>
          </div>

          <div className={classNames(css.imageRow, css.imageRowDesktop)}>
            <div className={css.imgBlock}>
              <img
                src="https://d1hdnpfpyy58x9.cloudfront.net/context/frontend/landing/landing02/experience_04.jpg,w_278,h_390,c_1,q_80,fd_1,e_.webp"
                alt={intl.formatMessage({ id: 'SectionEnjoyTheExperience.imageAlt4' })}
              />
            </div>
          </div>

          <div className={css.imageRow}>
            <div className={css.imgBlock}>
              <img
                src="https://d1hdnpfpyy58x9.cloudfront.net/context/frontend/landing/landing02/experience_05.jpg,w_278,h_396,c_1,q_80,fd_1,e_.webp"
                alt={intl.formatMessage({ id: 'SectionEnjoyTheExperience.imageAlt5' })}
              />
            </div>
            <div className={css.imgBlock}>
              <img
                src="https://d1hdnpfpyy58x9.cloudfront.net/context/frontend/landing/landing02/experience_06.jpg,w_278,h_279,c_1,q_80,fd_1,e_.webp"
                alt={intl.formatMessage({ id: 'SectionEnjoyTheExperience.imageAlt6' })}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SectionEnjoyTheExperience;